<template>
<div class="chapter">
<div class="inner_page">
<h2 class="CN" id="bk1"><span class="small"><a href="#/text/9780062365606_Contents#rbk1">BOOK ONE</a></span></h2>
<h3 class="CN1"><a href="#/text/9780062365606_Contents#rbk1">the grand tour</a></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062365606_Book_1.vue?570112d1